// extracted by mini-css-extract-plugin
export default {"google-inline-widget":"Book_google-inline-widget__RA4Rh","refund-schedule-table":"Book_refund-schedule-table__UQBXC"};